import { isValidEmail, isValidPhone } from '@/utils';

export const BILLING_SOFTWARE_OPTIONS = [
  'Diapaz',
  'Gestisoft',
  'Jarvis Legal',
  'Kleos',
  'LawyerIT',
  'Lexisnexis',
  'Poly Office',
  'Septeo Solutions Avocats',
  'Wolter Kluwer',
  'Autre',
] as const;

export type BillingSoftwareOption = (typeof BILLING_SOFTWARE_OPTIONS)[number] | '';

export type ContactFormData = {
  cabinet: string;
  usersCount: string;
  nom: string;
  prenom: string;
  email: string;
  telephone: string;
  message: string;
  billingSoftware: BillingSoftwareOption;
};

export type FormErrors = Partial<Record<keyof ContactFormData, string>>;

export const INITIAL_FORM: ContactFormData = {
  cabinet: '',
  usersCount: '',
  nom: '',
  prenom: '',
  email: '',
  telephone: '',
  message: '',
  billingSoftware: '',
};

export function validateContactForm(form: ContactFormData): FormErrors {
  const errors: FormErrors = {};

  if (!form.cabinet.trim()) errors.cabinet = 'Le nom du cabinet est requis.';
  if (!form.usersCount.trim()) {
    errors.usersCount = "Le nombre d'utilisateurs est requis.";
  } else if (!/^\d+$/.test(form.usersCount) || Number(form.usersCount) <= 0) {
    errors.usersCount = "Indiquez un nombre d'utilisateurs valide.";
  }
  if (!form.nom.trim()) errors.nom = 'Le nom est requis.';
  if (!form.prenom.trim()) errors.prenom = 'Le prénom est requis.';

  if (!form.email.trim()) {
    errors.email = "L'adresse email est requise.";
  } else if (!isValidEmail(form.email)) {
    errors.email = "L'adresse email n'est pas valide.";
  }

  if (form.telephone && !isValidPhone(form.telephone)) {
    errors.telephone = "Le numéro de téléphone n'est pas valide.";
  }

  return errors;
}
